import React from "react"
import { FlexContainer, Container, Icon, colors } from "@carrotfertility/carotene"
import styled from "styled-components"

const StyledInputWrapper = styled(FlexContainer)({
  border: "2px solid white",
  "&:hover": {
    border: `2px solid ${colors.base.carrotOrange}`
  },
  "&:focus-within": {
    border: `2px solid ${colors.base.carrotOrange}`
  }
})

const StyledInput = styled.input({
  width: "100%",
  lineHeight: 1.5,
  fontWeight: 500,
  border: "none",
  "&:focus": {
    border: "none",
    outline: "none"
  },
  "::placeholder": {
    color: `${colors.base.black40}`,
    fontWeight: 400
  }
})

export const LocationInput = React.forwardRef(
  ({ placeholderText, ...props }: { placeholderText: string }, ref: React.RefObject<HTMLInputElement>): JSX.Element => {
    return (
      <StyledInputWrapper
        background="white"
        padding="small"
        borderRadius="6px"
        direction="row"
        alignItems="center"
        shadow="light"
      >
        <Container style={{ marginRight: "12px" }}>
          <Icon name="magnifyingGlass" size="medium" />
        </Container>
        <StyledInput placeholder={placeholderText} ref={ref} type="search" {...props} />
      </StyledInputWrapper>
    )
  }
)
LocationInput.displayName = "LocationInput"
